// extracted by mini-css-extract-plugin
export var printerCard = "_ao-1";
export var printerCardConfigured = "_ao-2";
export var printerCardError = "_ao-3";
export var printerCardsContainer = "_ao-0";
export var printerIcon = "_ao-8";
export var printerIconConfigured = "_ao-5";
export var printerIconContainer = "_ao-4";
export var printerIconError = "_ao-6";
export var printerIconUnconfigured = "_ao-7";
export var workstationsTableCard = "_ao-9";